import type { SidebarMenuItemType } from "../root/layout/SidebarMenuItem";
import { prefetch } from "../api/prefetch";
import { optionCategoryPageRoute } from "../optionCategoryList/OptionCategoryPage";
import { sharedOptionCategoryScope } from "./sharedOptionCategoryScope";
import { OPTION_CATEGORY_TYPE_CONFIG, OPTION_CATEGORY_TYPES } from "../optionCategoryList/optionCategoryTypeConfig";
import { OptionCategoryIcon3, RegistrationControllerIcon3, TenantIcon3 } from "../shared/icons";
import { isEnterpriseCustomerScope } from "./enterpriseCustomer";
import { organisationsGridPageRoutes, prefetchOrganisationsGridPage } from "./OrganisationsGridPage";
import { prefetchSharedProcessingsGridPage, sharedProcessingsGridPageRoutes } from "./SharedProcessingsGridPage";

export const enterpriseCustomerNavigationItems: Array<SidebarMenuItemType> = [
  {
    variant: "navigationItem",
    hasAccess: isEnterpriseCustomerScope,
    Icon: TenantIcon3,
    labelKey: "Sidebar.EnterpriseCustomer.Organisations",
    to: paths => paths.enterpriseCustomerOrganisations(),
    route: { path: "customer/organisations", children: organisationsGridPageRoutes },
    onHover: prefetchOrganisationsGridPage,
  },
  {
    variant: "navigationItem",
    hasAccess: ({ hasPermission, currentCustomer, currentOrganisation }) =>
      isEnterpriseCustomerScope({ currentCustomer, currentOrganisation }) &&
      hasPermission("nova-forms-api:enterprise-customers:registrations:manage"),
    Icon: RegistrationControllerIcon3,
    labelKey: "Sidebar.EnterpriseCustomer.SharedProcessings",
    to: paths => paths.sharedProcessingsGrid(),
    route: { path: "customer/shared-processings", children: sharedProcessingsGridPageRoutes },
    onHover: prefetchSharedProcessingsGridPage,
  },
  {
    variant: "accordionMenu",
    labelKey: "Sidebar.Categories",
    Icon: OptionCategoryIcon3,
    children: OPTION_CATEGORY_TYPES.map(categoryType => ({
      variant: "navigationItem",
      hasAccess: ({ hasPermission, currentCustomer, currentOrganisation }) =>
        isEnterpriseCustomerScope({ currentCustomer, currentOrganisation }) &&
        hasPermission(sharedOptionCategoryScope.permission(categoryType, "read")),
      labelKey: OPTION_CATEGORY_TYPE_CONFIG[categoryType].textKeys.title,
      to: paths => paths.enterpriseCustomerOptionCategoryList({ categoryType }),
      route: optionCategoryPageRoute(sharedOptionCategoryScope, categoryType),
      onHover: () => prefetch(sharedOptionCategoryScope.listQueryOptions(categoryType)),
    })),
  },
];
